import React, { FC } from 'react'

import { IconTickOutlineProps } from './IconTickOutline.types'
import * as Styled from './styles/IconTickOutline.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTickOutline: FC<IconTickOutlineProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTickOutlineProps['size'],
  isResponsive = false,
}: IconTickOutlineProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m19.275 30.672 3.352-4.25 12.818-16.25a3 3 0 0 1 2.412-1.142l1.22-.015 1.75-.025-1.645 2.5-1.83 2.797L25.55 32.334l-3.475 5.132c-.533.75-1.175 1.545-2.183 1.545-.91 0-1.54-.655-2.075-1.285l-10-11.053-.2-.25a2.33 2.33 0 0 1-.47-1.5 2.21 2.21 0 0 1 2.21-2.212c.705 0 1.185.28 1.785.72l8.133 7.242Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTickOutline
